export default {
  priceAdvisorSubHeader: {
    unavailable: 'The Kelley Blue Book® Price Advisor Fair Market Range cannot be displayed at this time because there is insufficient information.',
    hasStatePricingRules: {
      new: 'The Kelley Blue Book® Price Advisor is for research purposes only. It doesn’t factor in incentives or special offers.',
      used: 'The Kelley Blue Book® Price Advisor is for research purposes only.'
    },
    used: 'Updated weekly, the Kelley Blue Book® Price Advisor helps you better understand what others have been paying for this car recently.',
    new: 'Updated weekly, the Kelley Blue Book® Price Advisor helps you better understand what others have been paying for this car recently.  It doesn’t factor in incentives or special offers.'
  }
};